<template>
  <div id="drone-result-page">
    <div class="d-flex justify-end">
      <div class="mx-8 my-4">
        <div class="d-flex justify-end">
          <span class="black--text font-weight-bold" style='font-family:"MS Pゴシック", sans-serif !important; font-size: 11px'>Confidential</span>
        </div>
        <v-img :src="require('@/assets/images/report_header.png')" width="120px" eager></v-img>
      </div>
    </div>
    <div class="ma-10 mt-0" style="height: 930px;">
      <p class="font-weight-bold text-h5 mb-0">{{naviVisibleList.findIndex(item => item.text === 'ドローン検査結果') - 1}}. ドローン検査結果</p>
      <p class="text-subtitle-1 mb-0">総括<span class="red--text" v-if="!summary"><strong>（必要）</strong></span><span class="text-subtitle-2 red--text" v-show="editMode">（10行制限です）</span></p>
      <div class="mb-2">
        <p v-show="!editMode" v-html="displayText(summary)" id="summary_not_editmode"></p>
        <v-textarea
            id="summary"
            counter="10"
            :counter-value="getSummaryCounter"
            auto-grow
            outlined
            v-if="editMode"
            @change="changeSummary"
            v-model="summary"
            rows="1"
            no-resize
            hide-details="auto"
            placeholder="総括を入力してください。"
        ></v-textarea>
      </div>
      <v-simple-table style="margin-top: 38px;" >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left px-2" style="width: 22%; height: 30px;">
                検査結果
              </th>
              <th class="text-left px-2" style="width: 17%; height: 30px;">
                数量
              </th>
              <th class="text-left px-2" style="width: 9%; height: 30px;">
                割合[%]
              </th>
              <th class="text-left px-2" style="width: 52%; height: 30px;">
                特記事項
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in droneResultData" :key="item.errorType">
              <td style="height: 32px; font-size: 12px;" class="px-2">{{item.errorType}}</td>
              <td style="height: 32px; font-size: 12px;" class="text-right px-2">
                <div class="d-flex" style="width: 100%;">
                  <div style="width: 35%;">{{droneResult[item.type].errorNum.toLocaleString('en-US', {maximumFractionDigits:2})}}</div>
                  <div class="d-flex" style="width: 65%"><span class="justify-start"><span v-html="'&nbsp;'"></span>{{droneResult[item.type].errorUnit}}</span></div>
                </div>
              </td>
              <td style="height: 32px; font-size: 12px;" class="text-right px-2" v-if="item.type !== 'shadow'">
                <span v-if="droneResult[item.type].errorPercentage < 0.01 && droneResult[item.type].errorPercentage > 0">{{"&lt;0.01%"}}</span>
                <span v-else>{{droneResult[item.type].errorPercentage}}%</span>
              </td>
              <td style="height: 32px; font-size: 12px;" class="text-center px-2" v-else>
                <strong>ー</strong>
              </td>
              <td style="height: 32px;" class="px-2">
                <span v-if="!editMode">{{droneResult[item.type].errorNote}}</span>
                <v-text-field
                    height="25px"
                    style="font-size: small"
                    ref="input"
                    hide-details
                    dense
                    v-else
                    v-model="droneResult[item.type].errorNote"
                    outlined
                    single-line
                    type="text"
                    @blur="saveErrorNote(item.type)"
                    @change="removeFocus(index)"
                ></v-text-field>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <div class="mt-8">
        <apexchart height="320" type="bar" :options="chartErrorPercentageOptions" :series="errorPercentage"></apexchart>
      </div>
    </div>
    <div class="mr-8">
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐</span>
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">{{naviVisibleList.findIndex(item => item.text === 'ドローン検査結果') + 2}}/{{naviVisibleList.length + pdfPageNum + cropImagePageNum + 1}}</span>
      </div>
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 11px">Copyright East Engineering Co., Ltd. all rights reserved</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueApexCharts from 'vue-apexcharts';
import {store} from "@/store";

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
export default {
  name: "DroneResultPage",
  props: ['report', 'naviVisibleList', 'cropImagePageNum', 'editMode', 'pdfPageNum'],
  data() {
    return {
      summary: null,
      droneResultHeaders: [
        {text: '検査結果', value: 'errorType', width: '22%', class: 'font-weight-bold'},
        {text: '数量', value: 'errorNum', width: '17%', class: 'font-weight-bold'},
        {text: '割合[%]', value: 'errorPercentage', width: '9%', class: 'font-weight-bold'},
        {text: '特記事項', value: 'errorNote', width: '52%', class: 'font-weight-bold'},
      ],
      droneResultData: [
        {
          errorType: '周辺環境による影',
          type: 'shadow'
        },
        {
          errorType: 'ホットスポット',
          type: 'cell'
        },
        {
          errorType: 'マルチホットスポット',
          type: 'multicell'
        },
        {
          errorType: 'クラスタバイパス',
          type: 'cluster'
        },
        {
          errorType: 'モジュール異常',
          type: 'module'
        },
        {
          errorType: 'ストリング異常',
          type: 'string'
        },
      ],
      droneResult: {
        'length': 0,
        'cell': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null,
          'errorUnit': '枚'
        },
        'multicell': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null,
          'errorUnit': '枚'
        },
        'cluster': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null,
          'errorUnit': '枚'
        },
        'module': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null,
          'errorUnit': '枚'
        },
        'string': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null,
          'errorUnit': 'ストリング'
        },
        'junction': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null,
          'errorUnit': '枚'
        },
        'pid': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null,
          'errorUnit': '枚'
        },
        'shadow': {
          'errorNum': 0,
          'errorReasonNum': {
            'crack': 0,
            'sediment': 0,
            'vegetation': 0,
            'unknown': 0,
            'length': 0
          },
          'errorPercentage': 0,
          'errorNote': null,
          'errorUnit': 'ヵ所'
        },
      },

      chartErrorPercentageOptions: {
        chart: {
          type: 'bar',
          height: 280,
          toolbar: {
            show: false
          }
        },
        title: {
          text: 'パネル数における故障モードの割合',
          align: 'center',
          offsetY: 10,
          style: {
            fontWeight: 'normal'
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
            dataLabels: {
              position: 'top'
            }
          }
        },
        xaxis: {
          categories: ['ホットスポット', ['マルチ', 'ホットスポット'], 'クラスタバイパス', 'モジュール異常', 'ストリング異常'],
          labels: {
            formatter: (value) => {
              if (value < 0.01 && value > 0){
                return '<0.01%';
              }
              return value + '%';
            }
          },
          tickAmount: 10,
        },
        yaxis: {
          max: 100
        },
        tooltip: {
          y: {
            formatter: function(value) {
              if (value < 0.01 && value > 0){
                return '<0.01%';
              }
              return value + '%';
            }
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#333']
          },
          textAnchor: 'start',
          offsetX: 40,
          formatter: (value) => {
            if (value < 0.01 && value > 0){
              return '<0.01%';
              // return value.toFixed(1-Math.floor(Math.log(value)/Math.log(10))) + '%'
            }
            return Number(value).toFixed(2) + '%'
          }
        },
      },
      errorPercentage: [{
        name: 'エラー',
        data: [0,0,0,0,0],
      }],

      chartErrorReasonOptions: {
        colors : ['#4CAF50', '#2196F3', '#FF9800', '#9E9E9E'],
        chart: {
          type: 'bar',
          height: 190,
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: false
          },
        },
        title: {
          text: '故障モード別原因の割合',
          align: 'center',
          margin: 0,
          style: {
            fontWeight: 'normal'
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          }
        },
        xaxis: {
          categories: [
            'クラスタバイパス',
            ['マルチ', 'ホットスポット'],
            'ホットスポット'
          ],
          labels: {
            formatter: (value) => {
              if (value < 0.01 && value > 0){
                return '<0.01%';
              }
              return value + '%';
            }
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#333']
          },
          formatter: (value) => {
            if (value < 0.01 && value > 0){
              return '<0.01%';
              // return `${value.toFixed(1-Math.floor(Math.log(value)/Math.log(10)))}%`
            }
            else{
              if (value >= 0.01){
                return `${Math.round(value * 100)/100}%`;
              }
              return '';
            }
          }
        }
      },
      errorReason: [],
      annotation: null,
      folderId: this.$route.params.folderId,
      changed: false,
      row: 1,
    }
  },
  methods:{
    changeSummary(){
      this.axios
          .put('/api/report/droneresult/summary/' + this.folderId, {summary: this.summary})
          .then(() => {
            this.report.summary = this.summary;
          })
          .catch(() => {
            store.showErrorDialog('エラーが発生しました。再度試してください。');
          });
    },
    removeFocus(index){
      this.changed = true;
      this.$refs.input[index].blur();
    },
    saveErrorNote(errorType){
      if (this.changed){
        this.axios
            .put('/api/report/droneresult/notice/' + this.folderId, {errorType: errorType, notice: this.droneResult[errorType].errorNote})
            .then(() => {

            })
            .catch(() => {
              store.showErrorDialog('エラーが発生しました。再度試してください。');
            });
        this.changed = false;
      }
    },
    calculateErrorPercentage(val){
      if (val > 0){
        this.droneResult['shadow'].errorPercentage = this.droneResult['shadow'].errorNum/val*100;
        if (this.droneResult['shadow'].errorPercentage < 0.01 && this.droneResult['shadow'].errorPercentage > 0){
          this.droneResult['shadow'].errorPercentage = this.droneResult['shadow'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['shadow'].errorPercentage)/Math.log(10)));
        }
        else {
          this.droneResult['shadow'].errorPercentage = Number(this.droneResult['shadow'].errorNum/val*100).toFixed(2);
        }

        this.droneResult['cell'].errorPercentage = this.droneResult['cell'].errorNum/val*100;
        if (this.droneResult['cell'].errorPercentage < 0.01 && this.droneResult['cell'].errorPercentage > 0){
          this.droneResult['cell'].errorPercentage = this.droneResult['cell'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['cell'].errorPercentage)/Math.log(10)));
        }
        else {
          this.droneResult['cell'].errorPercentage = Number(this.droneResult['cell'].errorNum/val*100).toFixed(2);
        }


        this.droneResult['multicell'].errorPercentage = this.droneResult['multicell'].errorNum/val*100;
        if (this.droneResult['multicell'].errorPercentage < 0.01 && this.droneResult['multicell'].errorPercentage > 0){
          this.droneResult['multicell'].errorPercentage = this.droneResult['multicell'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['multicell'].errorPercentage)/Math.log(10)));
        }
        else {
          this.droneResult['multicell'].errorPercentage = Number(this.droneResult['multicell'].errorNum/val*100).toFixed(2);
        }


        this.droneResult['cluster'].errorPercentage = this.droneResult['cluster'].errorNum/val*100;
        if (this.droneResult['cluster'].errorPercentage < 0.01 && this.droneResult['cluster'].errorPercentage > 0){
          this.droneResult['cluster'].errorPercentage = this.droneResult['cluster'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['cluster'].errorPercentage)/Math.log(10)));
        }
        else {
          this.droneResult['cluster'].errorPercentage = Number(this.droneResult['cluster'].errorNum/val*100).toFixed(2);
        }


        this.droneResult['module'].errorPercentage = this.droneResult['module'].errorNum/val*100;
        if (this.droneResult['module'].errorPercentage < 0.01 && this.droneResult['module'].errorPercentage > 0){
          this.droneResult['module'].errorPercentage = this.droneResult['module'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['module'].errorPercentage)/Math.log(10)));
        }
        else {
          this.droneResult['module'].errorPercentage = Number(this.droneResult['module'].errorNum/val*100).toFixed(2);
        }


        this.droneResult['junction'].errorPercentage = this.droneResult['junction'].errorNum/val*100;
        if (this.droneResult['junction'].errorPercentage < 0.01 && this.droneResult['junction'].errorPercentage > 0){
          this.droneResult['junction'].errorPercentage = this.droneResult['junction'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['junction'].errorPercentage)/Math.log(10)));
        }
        else {
          this.droneResult['junction'].errorPercentage = Number(this.droneResult['junction'].errorNum/val*100).toFixed(2);
        }


        this.droneResult['pid'].errorPercentage = this.droneResult['pid'].errorNum/val*100;
        if (this.droneResult['pid'].errorPercentage < 0.01 && this.droneResult['pid'].errorPercentage > 0){
          this.droneResult['pid'].errorPercentage = this.droneResult['pid'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['pid'].errorPercentage)/Math.log(10)));
        }
        else {
          this.droneResult['pid'].errorPercentage = Number(this.droneResult['pid'].errorNum/val*100).toFixed(2);
        }


        this.droneResult['string'].errorPercentage = Number(0).toFixed(2);
        if (this.report.stringErrorModuleNum && this.droneResult['string'].errorNum > 0){
          this.droneResult['string'].errorPercentage = this.droneResult['string'].errorNum * this.report.stringErrorModuleNum/val * 100;
          if (this.droneResult['string'].errorPercentage < 0.01 && this.droneResult['string'].errorPercentage > 0){
            this.droneResult['string'].errorPercentage = this.droneResult['string'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['string'].errorPercentage)/Math.log(10)));
          }
          else {
            this.droneResult['string'].errorPercentage = Number(this.droneResult['string'].errorNum * this.report.stringErrorModuleNum/val * 100).toFixed(2);
          }
        }

        // this.droneResult['string'].errorPercentage = Math.round(this.droneResult['string'].errorNum/val*10000)/100;
        const data = [
          this.droneResult['cell'].errorPercentage,
          this.droneResult['multicell'].errorPercentage,
          this.droneResult['cluster'].errorPercentage,
          this.droneResult['module'].errorPercentage,
          this.droneResult['string'].errorPercentage
        ];
        if (this.droneResult['junction'].errorPercentage > 0){
          data.push(this.droneResult['junction'].errorPercentage);
          let check = true;
          this.chartErrorPercentageOptions.xaxis.categories.forEach((item) => {
            if (typeof item != "string"){
              if (item[0] == 'ジャンクション'){
                check = false;
              }
            }
          });
          if (check){
            this.chartErrorPercentageOptions.xaxis.categories.push(['ジャンクション', 'ボックス過熱']);
          }

          check = true;
          this.droneResultData.forEach((item) => {
            if (item.type == 'junction'){
              check = false;
            }
          });
          if (check){
            this.droneResultData.push({
              errorType: 'ジャンクションボックス過熱',
              type: 'junction'
            });
          }
        }
        if (this.droneResult['pid'].errorPercentage > 0){
          data.push(this.droneResult['pid'].errorPercentage);
          let check = true;
          this.chartErrorPercentageOptions.xaxis.categories.forEach((item) => {
            if (item == 'ＰＩＤ現象の疑い'){
              check = false;
            }
          });
          if (check){
            this.chartErrorPercentageOptions.xaxis.categories.push('ＰＩＤ現象の疑い');
          }

          check = true;
          this.droneResultData.forEach((item) => {
            if (item.type == 'pid'){
              check = false;
            }
          });
          if (check){
            this.droneResultData.push({
              errorType: 'ＰＩＤ現象の疑い',
              type: 'pid'
            });
          }
        }
        this.errorPercentage = [{
          name: 'エラー',
          data: data
        }];
      }
      else{
        this.errorPercentage = [{
          name: 'エラー',
          data: [0, 0, 0, 0, 0]
        }];
      }
    },
    displayText(text){
      if (text){
        return text.replaceAll('\n', '<br>');
      }
      else return null;
    },
    getSummaryCounter(){
      if (document.getElementById('summary')){
        return Math.floor(document.getElementById('summary').clientHeight / 21);
      }
      return this.row;
    },
    init(){
      const panelErrorTypes = this.report.filter.panel_error_types;
      this.annotation.panel_abnormality.list.forEach(item => {
        this.report[item.type] = false;
      })
      const annotationList = this.annotation.panel_abnormality.list.filter(item => {
        let check = true;
        if (panelErrorTypes.length > 0){
          if (item.type){
            check = check && panelErrorTypes.findIndex(error => error === item.type) >= 0;
          }
          else {
            check = check && panelErrorTypes.findIndex(error => error === 'undefined') >= 0;
          }
        }
        else {
          return false;
        }
        return check;
      });
      annotationList.forEach(item => {
        this.report[item.type] = true;
        this.droneResult.length++;
        this.droneResult[item.type].errorReasonNum.length++;
        this.droneResult[item.type].errorNum++;
        if (item.reason){
          this.droneResult[item.type].errorReasonNum[item.reason]++;
        }
        else {
          this.droneResult[item.type].errorReasonNum['unknown']++;
        }
      });
      this.calculateErrorPercentage(this.report.plantModuleNum);
      this.errorReason = [
        {
          name: '割れ',
          data: [this.droneResult['cluster'].errorReasonNum.crack, this.droneResult['multicell'].errorReasonNum.crack, this.droneResult['cell'].errorReasonNum.crack]
        },
        {
          name: '堆積物',
          data: [this.droneResult['cluster'].errorReasonNum.sediment, this.droneResult['multicell'].errorReasonNum.sediment, this.droneResult['cell'].errorReasonNum.sediment]
        },
        {
          name: '植生',
          data: [this.droneResult['cluster'].errorReasonNum.vegetation, this.droneResult['multicell'].errorReasonNum.vegetation, this.droneResult['cell'].errorReasonNum.vegetation]
        },
        {
          name: '不明',
          data: [this.droneResult['cluster'].errorReasonNum.unknown, this.droneResult['multicell'].errorReasonNum.unknown, this.droneResult['cell'].errorReasonNum.unknown]
        }
      ];
    },
    reset(){
      this.droneResult = {
        'length': 0,
            'cell': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null,
              'errorUnit': '枚'
        },
        'multicell': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null,
              'errorUnit': '枚'
        },
        'cluster': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null,
              'errorUnit': '枚'
        },
        'module': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null,
              'errorUnit': '枚'
        },
        'string': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null,
              'errorUnit': 'ストリング'
        },
        'junction': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null,
              'errorUnit': '枚'
        },
        'pid': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null,
              'errorUnit': '枚'
        },
        'shadow': {
          'errorNum': 0,
              'errorReasonNum': {
            'crack': 0,
                'sediment': 0,
                'vegetation': 0,
                'unknown': 0,
                'length': 0
          },
          'errorPercentage': 0,
              'errorNote': null,
              'errorUnit': 'ヵ所'
        },
      };
    },
    reportUpdated(){
      this.summary = this.report.summary;
      for (const [key, value] of Object.entries(this.report.droneResultNotice)) {
        this.droneResult[key].errorNote = value;
      }
    }
  },
  async created() {
    this.summary = this.report.summary;
    await this.axios
        .get('/api/annotation/' + this.folderId)
        .then((response) => {
          this.annotation = response.data.annotation;
          this.reset();
          this.init();
        });
    for (const [key, value] of Object.entries(this.report.droneResultNotice)) {
      this.droneResult[key].errorNote = value;
    }

    this.$root.$on('reportUpdated', this.reportUpdated);
  },
  mounted() {
    this.row = document.getElementById('summary_not_editmode').clientHeight / 21 - 1;
    if (this.row <= 0){
      this.row = 1;
    }
  },
  watch:{
    'report.plantModuleNum': function (val) {
      this.calculateErrorPercentage(val);
    },
    'report.stringErrorModuleNum': function (val) {
      if (val && this.report.plantModuleNum && this.droneResult['string'].errorNum > 0){
        this.droneResult['string'].errorPercentage = this.droneResult['string'].errorNum * val/this.report.plantModuleNum*100;
        if (this.droneResult['string'].errorPercentage < 0.01 && this.droneResult['string'].errorPercentage > 0){
          this.droneResult['string'].errorPercentage = this.droneResult['string'].errorPercentage.toFixed(1-Math.floor(Math.log(this.droneResult['string'].errorPercentage)/Math.log(10)));
        }
        else {
          this.droneResult['string'].errorPercentage = Number(this.droneResult['string'].errorNum * val/this.report.plantModuleNum*100).toFixed(2);
        }
      }
      else {
        this.droneResult['string'].errorPercentage = Number(0).toFixed(2);
      }
      const data = JSON.parse(JSON.stringify(this.errorPercentage[0].data));
      data[4] = this.droneResult['string'].errorPercentage;
      this.errorPercentage = [{
        name: 'エラー',
        data: data
      }];
    },
    'editMode': function (val) {
      if (val){
        if (document.getElementById('summary_not_editmode')){
          this.row = Math.floor(document.getElementById('summary_not_editmode').clientHeight / 21);
        }
      }
    },
    'report.filter': function (){
      this.reset();
      this.init();
    }
  },

  beforeDestroy() {
    this.$root.$off('reportUpdated', this.reportUpdated);
  }
}
</script>

<style scoped>
table, th, td {
  border: 1px solid black;
}
>>>.v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
>>> .v-input{
  font-size: 14px !important;
}
>>>.v-textarea textarea{
  margin-top: 0px !important;
  line-height: 1.5;
}
</style>
